import { render, staticRenderFns } from "./SizeInput.vue?vue&type=template&id=4d9044e8&"
import script from "./SizeInput.ts?vue&type=script&lang=js&"
export * from "./SizeInput.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports